<!-- @format -->
<template>
    <base-layout :group="group" group-title="OPINION" show-authors show-snippet10 />
</template>

<script>
import BaseLayout from './BaseLayout.vue';

export default {
    components: {
        BaseLayout
    },
    props: {
        group: {
            type: Array,
            required: true
        }
    }
};
</script>
